var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/EstimationApi/EstimationRepo/ComplexField.ts";
import * as t from 'io-ts';
export var ComplexField = t.type({
  name: t.string,
  formula: t.string,
  unit: t.string
}, 'ComplexField');